import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><div parentName="p" {...{
        "className": "mermaid"
      }}><svg parentName="div" {...{
          "aria-role-description": ["flowchart-v2"],
          "role": "graphics-document document",
          "viewBox": "-8 -8 793.84375 288",
          "style": {
            "maxWidth": "793.84375px"
          },
          "xmlns": "http://www.w3.org/2000/svg",
          "width": "100%",
          "id": "mermaid-0"
        }}><style parentName="svg">{`#mermaid-0{font-family:arial,sans-serif;font-size:16px;fill:#333;}#mermaid-0 .error-icon{fill:#552222;}#mermaid-0 .error-text{fill:#552222;stroke:#552222;}#mermaid-0 .edge-thickness-normal{stroke-width:2px;}#mermaid-0 .edge-thickness-thick{stroke-width:3.5px;}#mermaid-0 .edge-pattern-solid{stroke-dasharray:0;}#mermaid-0 .edge-pattern-dashed{stroke-dasharray:3;}#mermaid-0 .edge-pattern-dotted{stroke-dasharray:2;}#mermaid-0 .marker{fill:#333333;stroke:#333333;}#mermaid-0 .marker.cross{stroke:#333333;}#mermaid-0 svg{font-family:arial,sans-serif;font-size:16px;}#mermaid-0 .label{font-family:arial,sans-serif;color:#333;}#mermaid-0 .cluster-label text{fill:#333;}#mermaid-0 .cluster-label span,#mermaid-0 p{color:#333;}#mermaid-0 .label text,#mermaid-0 span,#mermaid-0 p{fill:#333;color:#333;}#mermaid-0 .node rect,#mermaid-0 .node circle,#mermaid-0 .node ellipse,#mermaid-0 .node polygon,#mermaid-0 .node path{fill:#ECECFF;stroke:#9370DB;stroke-width:1px;}#mermaid-0 .flowchart-label text{text-anchor:middle;}#mermaid-0 .node .label{text-align:center;}#mermaid-0 .node.clickable{cursor:pointer;}#mermaid-0 .arrowheadPath{fill:#333333;}#mermaid-0 .edgePath .path{stroke:#333333;stroke-width:2.0px;}#mermaid-0 .flowchart-link{stroke:#333333;fill:none;}#mermaid-0 .edgeLabel{background-color:#e8e8e8;text-align:center;}#mermaid-0 .edgeLabel rect{opacity:0.5;background-color:#e8e8e8;fill:#e8e8e8;}#mermaid-0 .labelBkg{background-color:rgba(232, 232, 232, 0.5);}#mermaid-0 .cluster rect{fill:#ffffde;stroke:#aaaa33;stroke-width:1px;}#mermaid-0 .cluster text{fill:#333;}#mermaid-0 .cluster span,#mermaid-0 p{color:#333;}#mermaid-0 div.mermaidTooltip{position:absolute;text-align:center;max-width:200px;padding:2px;font-family:arial,sans-serif;font-size:12px;background:hsl(80, 100%, 96.2745098039%);border:1px solid #aaaa33;border-radius:2px;pointer-events:none;z-index:100;}#mermaid-0 .flowchartTitleText{text-anchor:middle;font-size:18px;fill:#333;}#mermaid-0 :root{--mermaid-font-family:arial,sans-serif;}`}</style><g parentName="svg"><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "12",
              "markerWidth": "12",
              "markerUnits": "userSpaceOnUse",
              "refY": "5",
              "refX": "6",
              "viewBox": "0 0 10 10",
              "className": "marker flowchart",
              "id": "mermaid-0_flowchart-pointEnd"
            }}><path parentName="marker" {...{
                "style": {
                  "strokeWidth": "1",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "d": "M 0 0 L 10 5 L 0 10 z"
              }}></path></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "12",
              "markerWidth": "12",
              "markerUnits": "userSpaceOnUse",
              "refY": "5",
              "refX": "4.5",
              "viewBox": "0 0 10 10",
              "className": "marker flowchart",
              "id": "mermaid-0_flowchart-pointStart"
            }}><path parentName="marker" {...{
                "style": {
                  "strokeWidth": "1",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "d": "M 0 5 L 10 10 L 10 0 z"
              }}></path></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "11",
              "markerWidth": "11",
              "markerUnits": "userSpaceOnUse",
              "refY": "5",
              "refX": "11",
              "viewBox": "0 0 10 10",
              "className": "marker flowchart",
              "id": "mermaid-0_flowchart-circleEnd"
            }}><circle parentName="marker" {...{
                "style": {
                  "strokeWidth": "1",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "r": "5",
                "cy": "5",
                "cx": "5"
              }}></circle></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "11",
              "markerWidth": "11",
              "markerUnits": "userSpaceOnUse",
              "refY": "5",
              "refX": "-1",
              "viewBox": "0 0 10 10",
              "className": "marker flowchart",
              "id": "mermaid-0_flowchart-circleStart"
            }}><circle parentName="marker" {...{
                "style": {
                  "strokeWidth": "1",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "r": "5",
                "cy": "5",
                "cx": "5"
              }}></circle></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "11",
              "markerWidth": "11",
              "markerUnits": "userSpaceOnUse",
              "refY": "5.2",
              "refX": "12",
              "viewBox": "0 0 11 11",
              "className": "marker cross flowchart",
              "id": "mermaid-0_flowchart-crossEnd"
            }}><path parentName="marker" {...{
                "style": {
                  "strokeWidth": "2",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "d": "M 1,1 l 9,9 M 10,1 l -9,9"
              }}></path></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "11",
              "markerWidth": "11",
              "markerUnits": "userSpaceOnUse",
              "refY": "5.2",
              "refX": "-1",
              "viewBox": "0 0 11 11",
              "className": "marker cross flowchart",
              "id": "mermaid-0_flowchart-crossStart"
            }}><path parentName="marker" {...{
                "style": {
                  "strokeWidth": "2",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "d": "M 1,1 l 9,9 M 10,1 l -9,9"
              }}></path></marker><g parentName="g" {...{
              "className": "root"
            }}><g parentName="g" {...{
                "className": "clusters"
              }}><g parentName="g" {...{
                  "id": "subGraph1",
                  "className": "cluster default flowchart-label"
                }}><rect parentName="g" {...{
                    "height": "254.75",
                    "width": "437.984375",
                    "y": "6",
                    "x": "339.859375",
                    "ry": "0",
                    "rx": "0",
                    "style": {}
                  }}></rect><g parentName="g" {...{
                    "transform": "translate(495.609375, 6)",
                    "className": "cluster-label"
                  }}><foreignObject parentName="g" {...{
                      "height": "19",
                      "width": "126.484375"
                    }}><div parentName="foreignObject" {...{
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        },
                        "xmlns": "http://www.w3.org/1999/xhtml"
                      }}><span parentName="div" {...{
                          "className": "nodeLabel"
                        }}>{`Apollo GraphOS`}</span></div></foreignObject></g></g><g parentName="g" {...{
                  "id": "subGraph0",
                  "className": "cluster default flowchart-label"
                }}><rect parentName="g" {...{
                    "height": "272",
                    "width": "214.640625",
                    "y": "0",
                    "x": "0",
                    "ry": "0",
                    "rx": "0",
                    "style": {}
                  }}></rect><g parentName="g" {...{
                    "transform": "translate(33.09375, 0)",
                    "className": "cluster-label"
                  }}><foreignObject parentName="g" {...{
                      "height": "19",
                      "width": "148.453125"
                    }}><div parentName="foreignObject" {...{
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        },
                        "xmlns": "http://www.w3.org/1999/xhtml"
                      }}><span parentName="div" {...{
                          "className": "nodeLabel"
                        }}>{`Your infrastructure`}</span></div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "edgePaths"
              }}><path parentName="g" {...{
                  "markerEnd": "url(#mermaid-0_flowchart-pointEnd)",
                  "style": {
                    "fill": "none"
                  },
                  "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-serviceA LE-registry",
                  "id": "L-serviceA-registry-0",
                  "d": "M189.641,52L193.807,52C197.974,52,206.307,52,220.909,52C235.51,52,256.38,52,277.25,52C298.12,52,318.99,52,340.557,55.954C362.124,59.909,384.389,67.817,395.522,71.772L406.654,75.726"
                }}></path><path parentName="g" {...{
                  "markerEnd": "url(#mermaid-0_flowchart-pointEnd)",
                  "style": {
                    "fill": "none"
                  },
                  "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-serviceB LE-registry",
                  "id": "L-serviceB-registry-0",
                  "d": "M187.813,136L192.284,136C196.755,136,205.698,136,220.604,136C235.51,136,256.38,136,277.25,136C298.12,136,318.99,136,340.553,132.202C362.117,128.404,384.375,120.808,395.504,117.01L406.632,113.212"
                }}></path><path parentName="g" {...{
                  "markerEnd": "url(#mermaid-0_flowchart-pointEnd)",
                  "style": {
                    "fill": "none"
                  },
                  "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-registry LE-uplink",
                  "id": "L-registry-uplink-0",
                  "d": "M543.586,94.5L555.077,94.417C566.568,94.333,589.549,94.167,611.198,98.427C632.846,102.688,653.161,111.375,663.318,115.719L673.475,120.063"
                }}></path><path parentName="g" {...{
                  "markerEnd": "url(#mermaid-0_flowchart-pointEnd)",
                  "style": {
                    "fill": "none"
                  },
                  "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-router LE-uplink",
                  "id": "L-router-uplink-0",
                  "d": "M145.586,220L157.095,220C168.604,220,191.622,220,213.566,220C235.51,220,256.38,220,277.25,220C298.12,220,318.99,220,349.385,220C379.781,220,419.703,220,465.148,220C510.594,220,561.563,220,599.643,209.483C637.723,198.966,662.916,177.931,675.512,167.414L688.108,156.897"
                }}></path></g><g parentName="g" {...{
                "className": "edgeLabels"
              }}><g parentName="g" {...{
                  "transform": "translate(277.25, 52)",
                  "className": "edgeLabel"
                }}><g parentName="g" {...{
                    "transform": "translate(-37.609375, -19)",
                    "className": "label"
                  }}><foreignObject parentName="g" {...{
                      "height": "38",
                      "width": "75.21875"
                    }}><div parentName="foreignObject" {...{
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        },
                        "xmlns": "http://www.w3.org/1999/xhtml"
                      }}><span parentName="div" {...{
                          "className": "edgeLabel"
                        }}>{`Publishes`}<br parentName="span"></br>{`schema`}</span></div></foreignObject></g></g><g parentName="g" {...{
                  "transform": "translate(277.25, 136)",
                  "className": "edgeLabel"
                }}><g parentName="g" {...{
                    "transform": "translate(-37.609375, -19)",
                    "className": "label"
                  }}><foreignObject parentName="g" {...{
                      "height": "38",
                      "width": "75.21875"
                    }}><div parentName="foreignObject" {...{
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        },
                        "xmlns": "http://www.w3.org/1999/xhtml"
                      }}><span parentName="div" {...{
                          "className": "edgeLabel"
                        }}>{`Publishes`}<br parentName="span"></br>{`schema`}</span></div></foreignObject></g></g><g parentName="g" {...{
                  "transform": "translate(612.53125, 94)",
                  "className": "edgeLabel"
                }}><g parentName="g" {...{
                    "transform": "translate(-33.140625, -19)",
                    "className": "label"
                  }}><foreignObject parentName="g" {...{
                      "height": "38",
                      "width": "66.28125"
                    }}><div parentName="foreignObject" {...{
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        },
                        "xmlns": "http://www.w3.org/1999/xhtml"
                      }}><span parentName="div" {...{
                          "className": "edgeLabel"
                        }}>{`Updates`}<br parentName="span"></br>{`config`}</span></div></foreignObject></g></g><g parentName="g" {...{
                  "transform": "translate(459.625, 220)",
                  "className": "edgeLabel"
                }}><g parentName="g" {...{
                    "transform": "translate(-94.765625, -9.5)",
                    "className": "label"
                  }}><foreignObject parentName="g" {...{
                      "height": "19",
                      "width": "189.53125"
                    }}><div parentName="foreignObject" {...{
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        },
                        "xmlns": "http://www.w3.org/1999/xhtml"
                      }}><span parentName="div" {...{
                          "className": "edgeLabel"
                        }}>{`Polls for config changes`}</span></div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "nodes"
              }}><g parentName="g" {...{
                  "transform": "translate(459.625, 94)",
                  "id": "flowchart-registry-3",
                  "className": "node default secondary flowchart-label"
                }}><polygon parentName="g" {...{
                    "style": {},
                    "transform": "translate(-83.4609375,17)",
                    "className": "label-container",
                    "points": "8.5,0 158.421875,0 166.921875,-17 158.421875,-34 8.5,-34 0,-17"
                  }}></polygon><g parentName="g" {...{
                    "transform": "translate(-67.4609375, -9.5)",
                    "style": {},
                    "className": "label"
                  }}><rect parentName="g"></rect><foreignObject parentName="g" {...{
                      "height": "19",
                      "width": "134.921875"
                    }}><div parentName="foreignObject" {...{
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        },
                        "xmlns": "http://www.w3.org/1999/xhtml"
                      }}><span parentName="div" {...{
                          "className": "nodeLabel"
                        }}>{`Schema Registry`}</span></div></foreignObject></g></g><g parentName="g" {...{
                  "transform": "translate(711.7578125, 136)",
                  "id": "flowchart-uplink-4",
                  "className": "node default secondary flowchart-label"
                }}><polygon parentName="g" {...{
                    "style": {},
                    "transform": "translate(-41.0859375,17)",
                    "className": "label-container",
                    "points": "8.5,0 73.671875,0 82.171875,-17 73.671875,-34 8.5,-34 0,-17"
                  }}></polygon><g parentName="g" {...{
                    "transform": "translate(-25.0859375, -9.5)",
                    "style": {},
                    "className": "label"
                  }}><rect parentName="g"></rect><foreignObject parentName="g" {...{
                      "height": "19",
                      "width": "50.171875"
                    }}><div parentName="foreignObject" {...{
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        },
                        "xmlns": "http://www.w3.org/1999/xhtml"
                      }}><span parentName="div" {...{
                          "className": "nodeLabel"
                        }}>{`Uplink`}</span></div></foreignObject></g></g><g parentName="g" {...{
                  "transform": "translate(107.3203125, 52)",
                  "id": "flowchart-serviceA-0",
                  "className": "node default default flowchart-label"
                }}><rect parentName="g" {...{
                    "height": "34",
                    "width": "164.640625",
                    "y": "-17",
                    "x": "-82.3203125",
                    "ry": "0",
                    "rx": "0",
                    "style": {},
                    "className": "basic label-container"
                  }}></rect><g parentName="g" {...{
                    "transform": "translate(-74.8203125, -9.5)",
                    "style": {},
                    "className": "label"
                  }}><rect parentName="g"></rect><foreignObject parentName="g" {...{
                      "height": "19",
                      "width": "149.640625"
                    }}><div parentName="foreignObject" {...{
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        },
                        "xmlns": "http://www.w3.org/1999/xhtml"
                      }}><span parentName="div" {...{
                          "className": "nodeLabel"
                        }}>{`Products subgraph`}</span></div></foreignObject></g></g><g parentName="g" {...{
                  "transform": "translate(107.3203125, 136)",
                  "id": "flowchart-serviceB-1",
                  "className": "node default default flowchart-label"
                }}><rect parentName="g" {...{
                    "height": "34",
                    "width": "160.984375",
                    "y": "-17",
                    "x": "-80.4921875",
                    "ry": "0",
                    "rx": "0",
                    "style": {},
                    "className": "basic label-container"
                  }}></rect><g parentName="g" {...{
                    "transform": "translate(-72.9921875, -9.5)",
                    "style": {},
                    "className": "label"
                  }}><rect parentName="g"></rect><foreignObject parentName="g" {...{
                      "height": "19",
                      "width": "145.984375"
                    }}><div parentName="foreignObject" {...{
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        },
                        "xmlns": "http://www.w3.org/1999/xhtml"
                      }}><span parentName="div" {...{
                          "className": "nodeLabel"
                        }}>{`Reviews subgraph`}</span></div></foreignObject></g></g><g parentName="g" {...{
                  "transform": "translate(107.3203125, 220)",
                  "id": "flowchart-router-2",
                  "className": "node default default flowchart-label"
                }}><rect parentName="g" {...{
                    "height": "34",
                    "width": "76.53125",
                    "y": "-17",
                    "x": "-38.265625",
                    "ry": "17",
                    "rx": "17",
                    "style": {}
                  }}></rect><g parentName="g" {...{
                    "transform": "translate(-26.515625, -9.5)",
                    "style": {},
                    "className": "label"
                  }}><rect parentName="g"></rect><foreignObject parentName="g" {...{
                      "height": "19",
                      "width": "53.03125"
                    }}><div parentName="foreignObject" {...{
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        },
                        "xmlns": "http://www.w3.org/1999/xhtml"
                      }}><span parentName="div" {...{
                          "className": "nodeLabel"
                        }}>{`Router`}</span></div></foreignObject></g></g></g></g></g></svg></div></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      